import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VOverlay,{attrs:{"opacity":"0.88","color":"graylight","value":_vm.enabled}},[_c(VProgressCircular,{attrs:{"color":"primary","indeterminate":"","size":"48"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }